import React from 'react';

const AboutForm = () => {
    return (
        <>
            <div className="section_header">
                <img src="images/title_border.png" alt="" />
                <h2 className="section_title">Reserve Your Table</h2>
                <h6 className="section_sub_title">Book a table in advance to enjoy your time with friends & Family</h6>
            </div>
            <div className="table_reserve_form">
                <form className="reserve_form" action="contact.php" method="post">
                    <div className="form-container">
                        <div className="form-group">
                            <label for="name">Your Name</label>
                            <input type="text" id="name" name="name" className="form-control" placeholder="Ex: John Doe" required="" />
                        </div>
                        <div className="form-group">
                            <label for="number">No. of Person</label>
                            <input type="number" id="number" name="number" className="form-control" placeholder="No. of Person" value="" min="1" required="" />
                        </div>
                        <div className="form-group">
                            <label for="date">Date</label>
                            <input type="date" id="date" name="date" className="form-control" required="" />
                        </div>
                        <div className="form-group">
                            <label for="time">Time</label>
                            <input type="time" id="time" name="time" className="form-control" required="" />
                        </div>
                        <div className="button_group">
                            <input className="button" type="submit" value="Reserve A Table" name="submit" />
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default AboutForm;